import { Response } from 'miragejs';
import { faker } from '@faker-js/faker';
import config from 'garaje/config/environment';

const findUiHooks = function (uiHooks, { locationIds, triggerNames, zoneIds }) {
  return uiHooks.where((hook) => {
    if (locationIds && locationIds.length > 0 && !locationIds.includes(hook.locationId)) {
      return false;
    } else if (zoneIds && zoneIds.length > 0 && !zoneIds.includes(hook.zoneId)) {
      return false;
    }

    return triggerNames?.length ? triggerNames.includes(hook.triggerName) : true;
  });
};

/**
 * Mirage routes for Hooks service
 */
export default function () {
  this.urlPrefix = config.hooksHost;

  this.get('/a/hooks/v1/locations/:location/hooks/ui', ({ uiHooks }, request) => {
    const locationIds = [request.params.location];
    const triggerNames = [].concat(request.queryParams['triggerName'], request.queryParams['triggerNames']).compact();

    return findUiHooks(uiHooks, { locationIds, triggerNames });
  });

  this.get('/a/hooks/v1/locations/hooks/ui', ({ uiHooks }, request) => {
    const locationIds = [].concat(request.queryParams['locationId'], request.queryParams['locationIds']).compact();
    const triggerNames = [].concat(request.queryParams['triggerName'], request.queryParams['triggerNames']).compact();

    return findUiHooks(uiHooks, { locationIds, triggerNames });
  });

  this.get('/a/hooks/v1/zones/hooks/ui', ({ uiHooks }, request) => {
    const zoneIds = request.queryParams.zoneIds;
    const triggerNames = [].concat(request.queryParams['triggerName'], request.queryParams['triggerNames']).compact();

    return findUiHooks(uiHooks, { triggerNames, zoneIds });
  });

  this.post('/a/hooks/v1/zones/hooks/ui/trigger', function (schema, request) {
    if (!window._GarajeUiHookResponses) {
      // return an empty-but-successful response so nothing breaks
      return new Response(200, {}, { data: [] });
    }
    const body = JSON.parse(request.requestBody);
    const resourceIds = body.resourceId ? [body.resourceId] : body.resourceIds || [];
    const triggerNames = body.triggerNames;

    const data = resourceIds.flatMap((resourceId) => {
      return triggerNames.flatMap((triggerName) => {
        const responses = window._GarajeUiHookResponses.getUiHookResponses(triggerName, resourceId);
        return responses.map((response) => {
          return {
            hookId: response.uiHookId,
            id: faker.string.uuid(),
            resourceId,
            responseHTML: response.content.html,
            responseJSON: response.content.json,
            status: 'DONE',
            triggerName,
          };
        });
      });
    });

    return new Response(200, {}, { data });
  });
}
